export default {
	section_banner: {
		title: {
			one: '支払う',
			two: 'あなたのところで',
		},
		main_title: {
			one: 'よく行くストア',
		},
		sub_title: {
			one: 'と',
			two: 'ワンテザー',
		},
		paragraph: {
			one: 'お客様自身で迅速にお支払いいただけます。ぜひJPWorldPayをお試しください。',
			two: '現金やカードを使わずに携帯電話ですぐに支払いができます。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},
	qr_pay: {
		label: '3ステップ決済',
		title: {
			one: 'QRペイ',
			two: 'JPWorldPay を使用する',
		},
		paragraph:
			'iPhone の QR アイコンをタップし、販売者がコードを提示したときに「スキャン」を選択するか、QR コードを要求している場合は「表示して支払う」をタップします。毎回、迅速、簡単、安全に行うことができます。',
		white_box_1st: {
			heading: 'スキャンまたは表示',
			paragraph:
				'JPWorldPay で支払いを完了するには、コードをスキャンまたは提示します。',
		},
		white_box_2nd: {
			heading: '支払いをする',
			paragraph:
				'JPWorldPay を使用すると、いつでもシームレスに支払いを行うことができます。',
		},
		white_box_3rd: {
			heading: 'お支払いは当社で',
			paragraph: 'JPWorldPayでご希望の暗号通貨でお支払いください。',
		},
	},
	future_currency_sec: {
		label: 'ワンテザーウォレット',
		title: {
			one: 'へようこそ',
			two: '将来の通貨',
			three: 'システム',
		},
		future_white_box_1st: {
			heading: '安全な支払い',
			paragraph: 'JPWorldPay は、QR コード取引中にお客様の情報を開示しません。',
		},
		future_white_box_2nd: {
			heading: 'どの会社でも',
			paragraph:
				'24 時間いつでもどこでも、オフラインの加盟店で即時安全にお支払いいただけます。',
		},
		future_white_box_3rd: {
			heading: 'タッチフリー',
			paragraph:
				'現金やクレジットカードを気にする必要はありません。アプリケーションを開いて支払います。',
		},
	},
	online_mid: {
		label: '最速の支払いシステム',
		title: {
			one: 'よろしくお願いします',
			two: '楽しむ',
			three: 'またまた',
		},
		paragraph: {
			one: 'JPWorldPayでご購入いただくと、次回のお買い物に使えるポイントが貯まります。JPWorldPayポイントはJPWorldPayをご利用いただけるすべての加盟店でご利用いただけますので、お買い物が簡単かつお得になります。スムーズな取引で、お買い物のたびに大きな節約が実現します。さらに、JPWorldPayユーザー限定の特典や割引もご利用いただけます。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},
	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
